const prefix = "AUTH::";

export const SIGN_IN = `${prefix}SIGN_IN`;
export const SIGN_OUT = `${prefix}SIGN_OUT`;
export const IS_AUTHORIZED = `${prefix}IS_AUTHORIZED`;
export const SET_READY = `${prefix}SET_READY`;